function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M15.75 2.51a1.55 1.55 0 00-1.096.455l-11.25 11.25a1.55 1.55 0 00-.454 1.096V19.5a1.55 1.55 0 001.55 1.55h4.19a1.55 1.55 0 001.095-.454l11.25-11.25a1.55 1.55 0 000-2.192l-4.189-4.19a1.55 1.55 0 00-1.096-.453zm0 1.621L13.881 6 18 10.119l1.869-1.869zM4.881 15l7.869-7.869 4.119 4.119L9 19.119zm-.331 1.931v2.519h2.519z",
    fill: props.fill,
    fillRule: "evenodd"
  }));
}

export default SvgPencil;